import { Eta as EtaCore } from "./internal.ts";

export class Eta extends EtaCore {}
